module.exports = __webpack_public_path__ + "img/05.80fb6da7.jpg";